import { render, staticRenderFns } from "./MobileManualDetail.vue?vue&type=template&id=35418198&scoped=true"
import script from "./MobileManualDetail.vue?vue&type=script&lang=js"
export * from "./MobileManualDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileManualDetail.vue?vue&type=style&index=0&id=35418198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35418198",
  null
  
)

export default component.exports